export default __webpack_public_path__ + "static/media/award-line2.80f69ddb.svg";